import React, { useState } from "react";
import { IconButton } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

import { quoteApi } from "@/main/api";
import { QuoteXmlRequest } from "@/main/models/request";
import { PartSearchResponse, QuoteSelectSuppliersDataResponse, QuoteXmlResponse } from "@/main/models/response";
import { useCreateOrderContext } from "@/main/screens/order/createorder/context";
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { downloadXML } from "@/main/services/utilsFile";

import SecondaryButton from "../button/secondaryButton";
import { SpinnerLoading } from "../styles";
import TooltipComponent from "../tooltip/tooltipComponent";
import WrapperModalDownloadXML from "./modalDownloadXML/modalDownloadXML";
import WrapperModalUploadXML from "./modalUploadXML/modalUploadXML";
import WrapperModalVideo from "./modalVideo/modalVideo";
import * as S from "./styles";

interface IKOGButtonsTriggerPaintProjectProps {
	guidQuote: string;
	part: PartSearchResponse;
	selectSupplier?: QuoteSelectSuppliersDataResponse;
}
function KOGButtonsTriggerPaintProject({ guidQuote, part, selectSupplier }: IKOGButtonsTriggerPaintProjectProps) {
	const { resultQuoteDetail, setIsUploadPaint, isUploadPaint } = useCreateOrderContext();

	const [isLoadingPaintProject, setIsLoadingPaintProject] = useState<boolean>(false);
	const [isOpenModalDownloadXML, setIsOpenModalDownloadXML] = useState<boolean>(false);
	const [isOpenModalUploadXML, setIsOpenModalUploadXML] = useState<boolean>(false);
	const [isOpenModalVideo, setIsOpenModalVideo] = useState<boolean>(false);
	const [dataPaintProject, setDataPaintProject] = useState<QuoteXmlResponse | null>(null);

	async function downloadPaintProjectXML() {
		setIsLoadingPaintProject(true);
		const request = {
			quoteGuid: guidQuote,
			partGuid: part.guid,
			findMoreSuppliers: false,
			automaticQuote: false,
			isSearchPart: isNullUndefined(selectSupplier) ? true : false,
		} as QuoteXmlRequest;

		quoteApi
			.quoteXml(request)
			.then((response) => {
				const { result } = response.data;
				const nameFile = result.jobNumber;
				downloadXML(result.quoteXml, `${nameFile}.xml`);
				setDataPaintProject(result);
				setIsOpenModalDownloadXML(true);
				setIsUploadPaint(true);
			})
			.finally(() => {
				setIsLoadingPaintProject(false);
			});
	}
	async function uploadPaintProjectXML() {
		setIsOpenModalUploadXML(true);
	}

	function handleClickButton(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();
		if (isUploadPaint) {
			uploadPaintProjectXML();
		} else {
			downloadPaintProjectXML();
		}
	}

	function handleClickIcon(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();

		setIsOpenModalVideo(true);
	}

	const renderText = isUploadPaint
		? getTranslateByKey("information.createPaintOrder")
		: getTranslateByKey("information.createFileRefinity");
	return (
		<S.Container>
			<SecondaryButton
				id="id-createOrder-button-card-paint"
				disabled={isLoadingPaintProject}
				onClick={handleClickButton}
			>
				{isLoadingPaintProject ? <SpinnerLoading size="xsmall" /> : renderText}
			</SecondaryButton>
			<S.AreaIconVideo>
				<TooltipComponent title={getTranslateByKey("information.clickHereMoreInformation")} placement="top">
					<IconButton id="id-createOrder-icon-help-video" onClick={handleClickIcon}>
						<HelpIcon color="primary" />
					</IconButton>
				</TooltipComponent>
			</S.AreaIconVideo>
			<WrapperModalDownloadXML
				isOpenModal={isOpenModalDownloadXML}
				dataPaintProject={dataPaintProject}
				setIsOpenModal={setIsOpenModalDownloadXML}
				closeModal={() => setIsOpenModalDownloadXML(false)}
			/>
			<WrapperModalUploadXML
				isOpenModal={isOpenModalUploadXML}
				dataPaintProject={dataPaintProject}
				selectSupplier={selectSupplier}
				part={part}
				setIsOpenModal={setIsOpenModalUploadXML}
				closeModal={() => setIsOpenModalUploadXML(false)}
			/>
			<WrapperModalVideo
				isOpenModal={isOpenModalVideo}
				urlVideo={String(resultQuoteDetail?.s3Video)}
				setIsOpenModal={setIsOpenModalVideo}
				openModal={() => setIsOpenModalVideo(true)}
				closeModal={() => setIsOpenModalVideo(false)}
			/>
		</S.Container>
	);
}

export default KOGButtonsTriggerPaintProject;
